import { CHECKOUT_URL, PRICE_VALUE, PRODUCT_NAME } from '../data/config';
import { trackPixelEvent } from './metaPixel';

export function hasCheckout(): boolean {
  return CHECKOUT_URL.trim().length > 0;
}

/** Devuelve la URL de compra conservando los parámetros UTM de la visita, o #oferta si no hay checkout. */
export function getCheckoutHref(): string {
  if (!hasCheckout()) return '#oferta';
  if (typeof window === 'undefined') return CHECKOUT_URL;
  try {
    const url = new URL(CHECKOUT_URL);
    const current = new URLSearchParams(window.location.search);
    current.forEach((value, key) => {
      if (key.toLowerCase().startsWith('utm_') && !url.searchParams.has(key)) {
        url.searchParams.set(key, value);
      }
    });
    return url.toString();
  } catch {
    return CHECKOUT_URL;
  }
}

/** Evento de Meta Pixel al ir al checkout (solo si hay checkout configurado). */
export function trackCheckoutClick(): void {
  if (!hasCheckout()) return;
  trackPixelEvent('InitiateCheckout', {
    content_name: PRODUCT_NAME,
    content_type: 'product',
    value: PRICE_VALUE,
    currency: 'ARS',
  });
}
